
import Events from './events';
import inhouseMapCtrl from './controllers/MapController';
import VGMapController from './controllers/VGMapController';
import SvelteController from './controllers/SvelteController';
import { instantiate } from './util';
import { ViewStateError } from './errors';
import { showLoading } from './loading-overlay';
import { createDataGate } from './data-gate';


import StartController from './controllers/StartController';
import StorelistController from './controllers/StorelistController';
import StoreController from './controllers/StoreController';
import TipsAndBenefitsController from './controllers/TipsAndBenefitsController';
import EventsAndNewsController from './controllers/EventsAndNewsController';




import LunchMenuController from './controllers/LunchMenuController';



export default function(context) {

  const mapCtrl = (({ mapType }) => {
    if (mapType.inhouse)          return inhouseMapCtrl;
    else if (mapType.visioglobe)  return VGMapController(context);
    else  throw new Error(`Unknown mapType '${mapType}'`);
  })(context.imdSettings);

  const searchController = instantiate(SvelteController);

  const routes = [
    { hash: '#start',  controller: StartController },
    { hash: '#list', controller: StorelistController },
    { hash: '#store',  controller: StoreController },
    { hash: '#tips',  controller: TipsAndBenefitsController },
    { hash: '#news',  controller: EventsAndNewsController },
    { hash: '#search',  controller: searchController },
    { hash: '#searchresults',  controller: searchController },
    { hash: '#maps',  controller: mapCtrl },
    { hash: '#hours',  controller: instantiate(SvelteController) },
    { hash: '#lunchmenu',  controller: LunchMenuController },
    { hash: '#thirdparty',
      controller: instantiate(SvelteController)
    }
  ];

  let defaultRoute = '#start';
  const state = {
    controller: null,
    hash: null
  };

  function startRouting(){
    window.location.hash = window.location.hash || defaultRoute;
    const startHash = window.location.hash;
    const loading = whenLanguageDataReady(startHash, () => {
      const started = loadControllerByHash(startHash, context);
      updateViewClass(startHash);
      return started;
    }, stayOnCurrentView);
    context.searchFromMapView = false;
    var lastHash;
    var newHash = window.location.hash.replace('#', '');

    window.onhashchange = function() {
      const { hash } = window.location;
      whenLanguageDataReady(hash, () => {
        // Not a change when stayOnCurrentView points the URL back
        const changed = hash != state.hash;
        loadControllerByHash(hash, context);
        updateViewClass(hash);
        if (changed) Events.dispatchEvent('view:change', hash.replace('#',''));
      }, stayOnCurrentView);
      lastHash = newHash;
      newHash = hash.replace('#','');
      context.lastHash = lastHash;
      if (newHash == 'maps') {
        context.searchFromMapView = true;
      } else if(newHash == 'start' || newHash == 'list') {
        context.searchFromMapView = false;
      }
    };

    return loading;
  }

  function findController (hash) {
    const route = routes.find(route => hash == route.hash);
    if (!route) {
      console.warn(`Can't find controller for '${hash}'`);
    }
    return route ? route.controller : null;
  }

  function loadControllerByHash(hash = defaultRoute, context) {

    const next = findController(hash);

    if (hash != state.hash && next) {
      const { controller: current } = state;
      const doExit = current && typeof current.exit == 'function';
      const ready = (doExit && current.exit()) || Promise.resolve();
      return ready
        .catch(e => console.error('Controller exit failed', state.hash, e))
        .then(() => {
          state.controller = next;
          state.hash = hash;
          next.start(context);
          Events.dispatchEvent('view:change:after', hash.replace('#',''));
        })
        .catch(e => {
          console.error('Controller start failed', hash, e);
          throw new ViewStateError('start', e);
        });
    }
  }

  /*
    Views read feeds of the current language, which may still be loading
    right after start-up or a language switch. Until they're stored, the
    current view stays as it is under a spinner overlay; then `go` switches
    the view. When the data is there `go` runs synchronously, as before.
    The start view doesn't need the feeds and re-renders itself on language
    change, so it never waits (keeps start-up fast). Neither does the view
    that is already open.
  */
  const whenLanguageDataReady = createDataGate({
    needsData: hash => hash != defaultRoute &&
      hash != state.hash &&
      typeof context.ensureLanguageData == 'function' &&
      !context.isLanguageDataLoaded(),
    ensureData: () => context.ensureLanguageData(),
    showLoading
  });

  // A view without its data would break, so a failed load keeps the current
  // view. The URL already names the new one: point it back, the hashchange
  // then finds that view open and goes through without waiting.
  function stayOnCurrentView(error) {
    console.error('Loading language data failed', error);
    window.location.replace(state.hash || defaultRoute);
  }

  const viewClassName = hash => `view-${hash.replace('#','')}`;
  const VIEW_CLASSES = routes.map(x => viewClassName(x.hash));

  /* Placing view class to body so that it can be used all around document */
  const updateViewClass = hash => {
    const body = document.body;
    const className = viewClassName(hash);
    body.classList.remove(...VIEW_CLASSES);
    body.classList.add(className);
  };

  return {
    startRouting
  };
}
